import { useState, useEffect } from "react";
import api from "../../services/api";

const formatMiles = (valor) => {
  const limpio = valor.toString().replace(/\D/g, "");
  if (!limpio) return "";
  return parseInt(limpio).toLocaleString("es-CL");
};

const desformatear = (valor) => valor.toString().replace(/\D/g, "");

export default function Personalizaciones() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ nombre: "", precio_extra: "" });

  useEffect(() => {
    cargar();
  }, []);

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await api.get("/personalizaciones/todas");
      setItems(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ nombre: "", precio_extra: "" });
    setModalAbierto(true);
  };

  const abrirEditar = (item) => {
    setEditando(item);
    setForm({ nombre: item.nombre, precio_extra: formatMiles(item.precio_extra) });
    setModalAbierto(true);
  };

  const handleGuardar = async () => {
    if (!form.nombre || form.precio_extra === "") {
      alert("Completa el nombre y el precio extra");
      return;
    }
    const payload = {
      nombre: form.nombre,
      precio_extra: desformatear(form.precio_extra),
    };
    try {
      if (editando) {
        await api.put(`/personalizaciones/${editando.id}`, payload);
      } else {
        await api.post("/personalizaciones", payload);
      }
      setModalAbierto(false);
      cargar();
    } catch (err) {
      console.error(err);
      alert("Error al guardar");
    }
  };

  const handleToggle = async (id) => {
    try {
      await api.patch(`/personalizaciones/${id}/toggle`);
      cargar();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Eliminar esta personalización?")) return;
    try {
      await api.delete(`/personalizaciones/${id}`);
      cargar();
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F1F4F9] flex items-center justify-center">
        <div className="text-[#1A56DB] text-sm">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F1F4F9] p-4">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 className="text-lg font-semibold text-gray-900">Personalizaciones</h1>
          <p className="text-xs text-gray-400 mt-0.5">
            Extras que la vendedora puede agregar a un pedido, con su costo adicional
          </p>
        </div>
        <button
          onClick={abrirNuevo}
          className="bg-[#1A56DB] hover:bg-[#1E429F] text-white text-sm font-medium px-4 py-2 rounded-lg transition-all"
        >
          + Agregar
        </button>
      </div>

      {items.length === 0 && (
        <div className="text-center text-gray-400 py-16 bg-white border border-[#E5E9F0] rounded-xl">
          No hay personalizaciones cargadas todavía.
        </div>
      )}

      {items.length > 0 && (
        <div className="bg-white border border-[#E5E9F0] rounded-xl overflow-x-auto shadow-sm">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[#E5E9F0] text-gray-400 text-xs uppercase">
                <th className="text-left px-4 py-2">Nombre</th>
                <th className="text-left px-4 py-2">Precio extra</th>
                <th className="text-left px-4 py-2">Estado</th>
                <th className="text-right px-4 py-2">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id} className="border-b border-gray-50">
                  <td className="px-4 py-3 font-medium text-gray-900">{item.nombre}</td>
                  <td className="px-4 py-3 text-gray-600">
                    +${parseInt(item.precio_extra).toLocaleString("es-CL")}
                  </td>
                  <td className="px-4 py-3">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${item.activo ? "bg-green-50 text-green-700 border border-green-200" : "bg-gray-100 text-gray-500 border border-[#E5E9F0]"}`}>
                      {item.activo ? "Activo" : "Inactivo"}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right space-x-3">
                    <button onClick={() => abrirEditar(item)} className="text-[#1A56DB] text-xs font-medium hover:underline">Editar</button>
                    <button onClick={() => handleToggle(item.id)} className="text-amber-600 text-xs font-medium hover:underline">{item.activo ? "Desactivar" : "Activar"}</button>
                    <button onClick={() => handleEliminar(item.id)} className="text-red-600 text-xs font-medium hover:underline">Eliminar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {modalAbierto && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center backdrop-blur-sm p-4">
          <div className="bg-white border border-[#E5E9F0] rounded-2xl p-6 w-full max-w-sm shadow-xl">
            <h3 className="text-gray-900 font-semibold text-lg mb-4">
              {editando ? "Editar personalización" : "Nueva personalización"}
            </h3>

            <div className="mb-3">
              <label className="text-xs text-gray-500 uppercase tracking-wider font-medium">Nombre</label>
              <input
                type="text"
                value={form.nombre}
                onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                placeholder="Ej: Decoración especial 3D"
                className="w-full mt-1 bg-[#F1F4F9] border border-[#E5E9F0] rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#1A56DB] focus:ring-1 focus:ring-[#1A56DB]"
              />
            </div>

            <div className="mb-4">
              <label className="text-xs text-gray-500 uppercase tracking-wider font-medium">Precio extra</label>
              <div className="relative mt-1">
                <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">$</span>
                <input
                  type="text"
                  inputMode="numeric"
                  value={form.precio_extra}
                  onChange={(e) => setForm({ ...form, precio_extra: formatMiles(e.target.value) })}
                  placeholder="0"
                  className="w-full bg-[#F1F4F9] border border-[#E5E9F0] rounded-lg pl-7 pr-3 py-2.5 text-sm focus:outline-none focus:border-[#1A56DB] focus:ring-1 focus:ring-[#1A56DB]"
                />
              </div>
            </div>

            <div className="flex gap-2">
              <button
                onClick={handleGuardar}
                className="flex-1 bg-[#1A56DB] hover:bg-[#1E429F] text-white font-semibold py-2.5 rounded-lg transition-all"
              >
                {editando ? "Guardar cambios" : "Crear"}
              </button>
              <button
                onClick={() => setModalAbierto(false)}
                className="bg-gray-100 hover:bg-gray-200 text-gray-600 px-4 rounded-lg transition-all"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
